<div class="ds-side-modal-container">
  <div class="ds-side-modal-container__header">
    <div
      class="d-flex justify-content-between align-items-start w-100 ds-gap-base"
      [ngClass]="{ 'justify-content-end': !modalData.title && !modalData.titleDsIcon }"
    >
      <div
        class="ds-side-modal-container__title-wrapper d-flex align-items-center flex-grow-1 ds-gap-3"
        *ngIf="modalData.title || modalData.titleDsIcon"
      >
        <ds-icon
          *ngIf="modalData.titleDsIcon"
          class="flex-shrink-0"
          [icon]="modalData.titleDsIcon"
          width="32px"
          height="32px"
          type="info"
          [addBackground]="true"
        ></ds-icon>
        <span *ngIf="modalData.title" class="ds-title ds-fc-base">{{ modalData.title }}</span>
      </div>
      <ds-icon
        icon="cross"
        class="ds-side-modal-container__close-icon cursor-pointer flex-shrink-0 ds-fc-primary-blue"
        (click)="close()"
      ></ds-icon>
    </div>

    <span *ngIf="modalData.description" class="ds-body-secondary-xl ds-font-secondary ds-fc-muted">{{
      modalData.description
    }}</span>
  </div>

  <div class="ds-side-modal-container__content" *ngIf="modalData.innerComponent">
    <ng-container *ngComponentOutlet="modalData.innerComponent; injector: childInjector"></ng-container>
  </div>
</div>
